import { cn } from '@/lib/utils';
import { MonitorSmartphone, Pill } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import CardProductType from './CardProductType';

interface Step1Props {
  onProductTypeSelected: (type: { value: string }) => void;
  selectedType: string;
}

export default function Step1({
  onProductTypeSelected,
  selectedType,
}: Step1Props) {
  const { t } = useTranslation(['common', 'onboarding']);

  const productTypeOptions = [
    {
      value: 'digital',
      label: t('digitalProduct'),
      description: t('digitalProductDescription'),
      icon: <MonitorSmartphone color='#fafafa' />,
      isEnabled: true,
    },
    // {
    //   value: 'physical',
    //   label: t('physicalProduct'),
    //   description: t('physicalProductDescription'),
    //   icon: <Box />,
    //   isEnabled: false,
    // },
    {
      value: 'pharmaceutical',
      label: t('nutraProduct'),
      description: t('nutraProductDescription'),
      icon: <Pill />,
      isEnabled: true,
    },
  ];

  const enabledProducts = productTypeOptions;
  const productCount = enabledProducts.length;

  const getGridClasses = () => {
    switch (productCount) {
      case 1:
        return 'grid-cols-1 max-w-md mx-auto';
      case 2:
        return 'grid-cols-1 md:grid-cols-2';
      case 3:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
      default:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
    }
  };

  return (
    <>
      <h1 className='text-2xl font-bold text-center'>
        {t('witch')}{' '}
        <strong className='text-interactive font-semibold'>
          {t('type_product')}
        </strong>{' '}
        <br />
        {t('step1Title')}
      </h1>
      <div className={cn('grid gap-4 mt-8', getGridClasses())}>
        {productTypeOptions.map((type) => (
          <CardProductType
            key={type.value}
            selectedType={selectedType}
            onClick={() => onProductTypeSelected(type)}
            isActive={selectedType === type.value}
            title={type.label}
            description={type.description}
            dataCy={`${type.value}-product`}
            icon={type.icon}
            isEnabled={type.isEnabled}
          />
        ))}
      </div>
    </>
  );
}
